import React from "react";
import { Autocomplete, TextField, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useField, useFormikContext } from "formik";
import TextFieldLabel from "./TextFieldLabel";

export default function SearchableDropdown({
  label,
  requiredMark,
  options = [],
  placeholder = "Select an option...",
  name,
}) {
  const theme = useTheme();

  // connect this component to Formik
  const [field, meta, helpers] = useField(name);
  const { setFieldValue, setFieldTouched } = useFormikContext();

  return (
    <Stack spacing={1}>
      <TextFieldLabel label={label} required={requiredMark} />

      <Autocomplete
        options={options}
        value={field.value || ""}
        onChange={(event, newValue) => setFieldValue(name, newValue)}
        onBlur={() => setFieldTouched(name, true)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            variant="outlined"
            size="small"
            name={name}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
          />
        )}
      />
    </Stack>
  );
}
